<div class="mobile-form">
  <ng-container *ngIf="showRate">
    <span class="area-container-label">
      Rate the condition
      <span *ngIf="rateRequired" class="required">*</span>
    </span>
    <div class="display-flex emoji-container">
      <div class="display-flex flex-column align-items-center">
        <app-template-editor-animation
          class="emoji"
          [attrHeight]="'32px'"
          [attrWidth]="'32px'"
          [autoplay]="false"
          [animationItem]="'1f60d'"></app-template-editor-animation>
        <span class="display-flex align-items-center">Good</span>
      </div>
      <div class="display-flex flex-column align-items-center">
        <app-template-editor-animation
          class="emoji"
          [attrHeight]="'32px'"
          [attrWidth]="'32px'"
          [autoplay]="false"
          [animationItem]="'1f610'"></app-template-editor-animation>
        <span class="display-flex align-items-center">Poor</span>
      </div>
      <div class="display-flex flex-column align-items-center">
        <app-template-editor-animation
          class="emoji"
          [attrHeight]="'32px'"
          [attrWidth]="'32px'"
          [autoplay]="false"
          [animationItem]="'274c'"></app-template-editor-animation>
        <span class="display-flex align-items-center">Repair required</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showPhotos">
    <div class="w-100 display-flex flex-column justify-content-space-between grid-gap-8" [attr.guid]="'guid-comment'">
      <span class="area-container-label">
        {{ photosLabel }}
        <span *ngIf="photosRequired" class="required">*</span>
      </span>
      <div class="area-container display-flex align-items-center justify-content-center overflow-hidden">
        <app-icon [iconHeight]="48" [iconWidth]="48" [svg]="photosIcon" [iconColor]="EColorPalette.cOrange2"></app-icon>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showComment">
    <div class="w-100 display-flex flex-column justify-content-space-between grid-gap-8" [attr.guid]="'guid-comment'">
      <span class="area-container-label">
        Add comment
        <span *ngIf="commentRequired" class="required">*</span>
      </span>
      <div class="area-container overflow-hidden">
        <span>Type your comment here...</span>
      </div>
    </div>
  </ng-container>

  <div *ngIf="showDone" class="mobile-done-button">Done</div>
</div>
